/** @format */

import { post, get } from '@root/utils/httpWrap';
//总览
export const getOverviewDataVisualization = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/getOverviewDataVisualization', params);
};

//通行
export const trafficDate = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/trafficDate', params);
};

//通行折线 /bangdao/saasapi/v1/datav/realTimeTraffic
export const realTimeTraffic = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/realTimeTraffic', params);
};
//地图车场数量显示
export const mapParking = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/mapParking', params);
};

//营收
export const revenueDate = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/revenueDate', params);
};

//营收折线 bangdao/saasapi/v1/datav/realRevenueDate
export const realRevenueDate = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/realRevenueDate', params);
};

//异常通行
export const abnormalTraffic = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/abnormalTraffic', params);
};
//异常通行
export const fiveabnormalTraffic = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/realTraffic', params);
};

//实时运维
export const datavOperation = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/operation', params);
};

//实时运维
export const operationFiveMinute = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/operationFiveMinute', params);
};

//实时实时车流量
export const trafficFlow = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/trafficFlow', params);
};

//获取parkId /bangdao/saasapi/v1/monitor/getParkIds
export const getParkIds = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/getParkIds', params);
};

//支付渠道/bangdao/saasapi/v1/datav/temporaryRevenueChannelRate
export const temporaryRevenueChannelRate = (params: any): Promise<any> => {
  return post('/bangdao/saasapi/v1/datav/temporaryRevenueChannelRate', params);
};
